module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/spot_06-cfa325b32c0354ca13d34f6597f63a16.webp";